import React, { useState } from "react";
import "./Adminlogin.css";

const AdminLogin = ({ onClose, onLoginSuccess }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false); // Added loading state

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true); // Start loading

    try {
      const response = await fetch('/api/db', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          action: 'admin-login', 
          data: { email, password } 
        })
      });

      const result = await response.json();

      if (response.ok && result.success) {
        onLoginSuccess();
      } else {
        alert(result.error || "Invalid credentials");
        setIsLoading(false); // Stop loading on error
      }
    } catch (err) {
      console.error("Admin Login Error:", err);
      alert("Network error. Please try again.");
      setIsLoading(false); // Stop loading on error
    }
  };

  return (
    <div className="admin-login-overlay">
      <div className="admin-login-box">
        <button className="close-btn" onClick={onClose}>&times;</button>

        <h2>Admin Login</h2>

        {isLoading ? (
          <div className="loading-box">
            <div className="spinner"></div>
            <p>Authenticating Admin...</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <input
              type="email"
              placeholder="Admin Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            <button type="submit">Login</button>
          </form>
        )}
      </div>
    </div>
  );
};

export default AdminLogin;

